import { defineComponent } from '@digitalbranch/app'

import { uiRipple } from '../../ripple/ripple'
import { uiBaseButton } from '../base-button/base-button'

import template from './icon-button.html'
import css from './icon-button.css'

export const uiIconButton = defineComponent({
  name: 'ui-icon-button',
  props: ['type', { name: 'disabled', type: 'boolean' }, { name: 'variant', type: 'string', default: 'standard' }],
  components: {
    uiBaseButton,
    uiRipple
  },
  template,
  css,
  formAssociated: true,
  delegatesFocus: false,
  listeners: {
    ready() {
      this.$node.setAttribute('role', this.to || this.href ? 'link' : 'button')

      this.$addEventListener(this.$node, 'focus', this.handleFocus.bind(this))
    },
    beforeDestroy() {
      this.$removeEventListener(this.$node, 'focus', this.handleFocus.bind(this))
    },
  },
  methods: {
    handleFocus() {
      this.$refs.button.focus()
    },
  },
  computed: {
    buttonClasses() {
      return [`ui-icon-button--variant-${this.variant}`, this.disabled && 'ui-icon-button--is-disabled']
    }
  }
})
